export default __webpack_public_path__ + "static/media/brazil.f5b91131.svg";